import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useIntl, defineMessages } from 'react-intl';
import { FontAwesomeIcon } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { Card, CardBody, Row, Col } from 'design-react-kit';

const messages = defineMessages({
  noResults: {
    id: 'rss_no_results',
    defaultMessage: 'No results from RSS feed.',
  },
});

const RSSMeteoCard = ({ items = [], isEditMode, data = {} }) => {
  const intl = useIntl();
  return (
    <div className={cx('', { 'public-ui': isEditMode })}>
      {items?.length > 0 ? (
        <>
          {data.title && (
            <Row>
              <Col>
                <h2 className="mb-4 mt-5">{data.title}</h2>
              </Col>
            </Row>
          )}
          <Row className="weather_alert">
            {items.map((item, index) => (
              <Col
                lg={12}
                className={item?.['categories']?.[1] + ' mb-12 item'}
                key={index}
              >
                <Card>
                  <CardBody tag="div">
                    <a href={item['url']} target="_blank" rel="noreferrer">
                      {item?.['categories']?.[3] !==
                      'fa fa-exclamation-triangle' ? (
                        <i className={item?.['categories']?.[3]} />
                      ) : (
                        <FontAwesomeIcon
                          icon={['fas', 'exclamation-triangle']}
                        />
                      )}
                      <span className="alert_type">
                        {item?.['categories']?.[2]}
                      </span>
                      <span className="mx-1">&mdash;</span>
                      {(item.pubDate || item.date) && (
                        <span className="rss_meteo_date">
                          {item.pubDate || item.date}
                        </span>
                      )}
                    </a>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      ) : data?.feeds?.length > 0 && isEditMode ? (
        <div className="no-rss-feed-results">
          {intl.formatMessage(messages.noResults)}
        </div>
      ) : null}
    </div>
  );
};

RSSMeteoCard.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
};

export default RSSMeteoCard;
